import React, { useState, useEffect } from 'react';

import { Container } from 'react-bootstrap';

import api from '../../services/api';

import Loading from '../../components/Loading';
import Iframe from '../../components/Iframe';

import IconeBotWhatsapp from '../../components/Header/components/IconeBotWhatsapp';

const urlPainel = process.env.REACT_APP_PAINEL_WHATSAPP_URL;

const WhatsappBotPainel: React.FC = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get('sessions/logado');
        console.log(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    loadDados();
  }, []);

  return (
    <Container
      fluid
      className="m-0 p-0"
      style={{ height: 'calc(100vh - 60px)' }}
    >
      {loading && <Loading backgroundBlack={false} />}
      {!loading && urlPainel && (
        <Iframe
          updateIframeTime={30000}
          src={urlPainel}
          headers={{ ClinicaBM: 'saudedr2026' }}
          title="Monitorar Bot Whatsapp"
          style={{
            border: '0',
            minHeight: '500px' /* Prevent collapse if content is empty */,
            maxHeight: '1500px' /* Avoid overly tall iframes */,
            overflowY: 'auto' /* Add scrollbar if max-height is exceeded */,
          }}
          loading="lazy" // Melhora performance
          sandbox="allow-scripts allow-same-origin allow-popups"
        />
      )}
      {!urlPainel && (
        <>
          <p className="text-center mt-4">
            <IconeBotWhatsapp size="450" />
          </p>
          <h2 className="text-center mt-4">
            Não existe painel configurado para essa unidade
          </h2>
        </>
      )}
    </Container>
  );
};

export default WhatsappBotPainel;
